module.exports = __webpack_public_path__ + "img/fly-bosnia.a2dc5d2b.png";